import { CONTRACT_GOVERNMENT_JOB_TITLE_HISTORY_BY_EMPLOYEE_ID } from '../Queries'
import { ApolloError, useQuery } from '@apollo/client'
import {
  ContractGovernmentJobTitleHistoryByEmployeeIdQuery,
  ContractGovernmentJobTitleHistoryByEmployeeIdQueryVariables,
} from '../../../types'

export default (
  employeeId: string,
  resigned = false,
): { data: ContractGovernmentJobTitleHistoryByEmployeeIdQuery | undefined; error: ApolloError | undefined; loading: boolean } => {
  const variables = {
    employeeId: employeeId,
    employeeResigned: resigned,
  }

  const { data, error, loading } = useQuery<
    ContractGovernmentJobTitleHistoryByEmployeeIdQuery,
    ContractGovernmentJobTitleHistoryByEmployeeIdQueryVariables
  >(CONTRACT_GOVERNMENT_JOB_TITLE_HISTORY_BY_EMPLOYEE_ID, {
    variables: variables,
  })

  return { data, error, loading }
}
